/* Kiddorie Style - theme.js
   Vanilla, no dependencies. Every behaviour degrades to a working link or
   form submit when JS is unavailable. */
(function () {
  'use strict';

  var focusReturn = null;

  /* ---------------- drawers ---------------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    focusReturn = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = d.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }

  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (focusReturn && focusReturn.focus) focusReturn.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
  });

  /* ---------------- quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty button');
    if (!btn) return;
    e.preventDefault();
    var input = btn.closest('.qty').querySelector('input');
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- cart ---------------- */
  function replaceSection(html, selector) {
    if (!html) return;
    var target = document.querySelector(selector);
    if (!target) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector(selector);
    if (source) target.innerHTML = source.innerHTML;
  }

  function applySections(sections) {
    if (!sections) return;
    replaceSection(sections['cart-drawer'], '#CartDrawerContents');
    replaceSection(sections['cart-icon-bubble'], '#CartIconBubble');
    replaceSection(sections['main-cart'], '#MainCart');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    var original = button ? button.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = '...'; }

    var body = new FormData(form);
    body.append('sections', 'cart-drawer,cart-icon-bubble,main-cart');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        applySections(data.sections);
        if (document.getElementById('CartDrawer')) openDrawer('CartDrawer');
        else window.location = window.routes.cart_url;
      })
      .catch(function (err) {
        var status = form.querySelector('[data-form-status]');
        if (status) {
          status.textContent = (err && err.message) || window.themeStrings.cartError;
          status.classList.add('form-status--error');
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .then(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.textContent = original; }
      });
  });

  function updateLine(line, quantity) {
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer,cart-icon-bubble,main-cart'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { applySections(data.sections); })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (input) updateLine(input.getAttribute('data-line'), input.value);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    updateLine(rm.getAttribute('data-line'), 0);
  });

  /* ---------------- variant picker ---------------- */
  document.addEventListener('change', function (e) {
    var root = e.target.closest('[data-variants]');
    if (!root) return;
    var json = root.querySelector('[data-variant-json]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);

    var chosen = Array.prototype.map.call(
      root.querySelectorAll('[data-option-index]'),
      function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      }
    );

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] && variants[i].options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) { match = variants[i]; break; }
    }

    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var idInput = root.querySelector('[data-variant-id]');

    if (!match) {
      if (addBtn) { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = window.themeStrings.unavailable; }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
    if (addBtn) {
      if (match.available) {
        addBtn.removeAttribute('disabled');
        addBtn.textContent = window.themeStrings.addToCart;
      } else {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.textContent = window.themeStrings.soldOut;
      }
    }
    if (window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }
  });

  /* ---------------- predictive search ---------------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search]');
    if (!input) return;
    var results = document.querySelector('[data-predictive-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch(window.routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var el = parsed.querySelector('[data-predictive-results]');
          results.innerHTML = el ? el.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 250);
  });

  /* ---------------- reveal on scroll ---------------- */
  function revealAll() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
  }

  if (document.body.classList.contains('anim-reveal') && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    revealAll();
  }

  /* ---------------- theme editor ---------------- */
  document.addEventListener('shopify:section:load', revealAll);
})();

/* Kiddorie additions: carousel, countdown, parallax, back to top.
   Same rules as above - no dependencies, everything degrades gracefully. */
(function () {
  'use strict';

  /* ---------------- carousel (scroll-snap + arrows) ---------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track || track.dataset.carouselReady) return;
    track.dataset.carouselReady = '1';

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var bar = root.querySelector('[data-carousel-bar]');

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        var progress = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = (visible * 100) + '%';
        bar.style.transform = 'translateX(' + (progress * (100 / visible - 100)) + '%)';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  /* ---------------- countdown ---------------- */
  function initCountdown(el) {
    if (el.dataset.countdownReady) return;
    el.dataset.countdownReady = '1';
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.hidden = true; return; }

    var out = {
      d: el.querySelector('[data-cd-d]'), h: el.querySelector('[data-cd-h]'),
      m: el.querySelector('[data-cd-m]'), s: el.querySelector('[data-cd-s]')
    };
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(timer);
        el.textContent = el.getAttribute('data-ended-text') || '';
        return;
      }
      var s = Math.floor(left / 1000);
      if (out.d) out.d.textContent = pad(Math.floor(s / 86400));
      if (out.h) out.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (out.m) out.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (out.s) out.s.textContent = pad(s % 60);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach(initCountdown);
  }

  /* ---------------- parallax ---------------- */
  var parallaxItems = [];
  function collectParallax(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (scope || document).querySelectorAll('[data-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img || el.dataset.parallaxReady) return;
      el.dataset.parallaxReady = '1';
      var amount = parseFloat(el.getAttribute('data-parallax-speed') || '8');
      img.classList.add('parallax');
      img.style.height = (100 + amount * 2) + '%';
      img.style.top = (-amount) + '%';
      img.style.position = 'absolute';
      parallaxItems.push({ el: el, img: img, amount: amount });
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking || !parallaxItems.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      parallaxItems.forEach(function (item) {
        var box = item.el.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var progress = (box.top + box.height / 2 - vh / 2) / vh;
        item.img.style.transform = 'translate3d(0,' + (progress * item.amount) + '%,0)';
      });
      ticking = false;
    });
  }

  /* ---------------- social rail tucks away on scroll ---------------- */
  var rail = document.querySelector('.fside[data-hide-on-scroll]');
  function syncRail() {
    if (!rail) return;
    rail.classList.toggle('is-tucked', window.scrollY > window.innerHeight * 0.6);
  }
  window.addEventListener('scroll', syncRail, { passive: true });
  syncRail();

  /* ---------------- back to top ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-back-to-top]')) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  function boot(scope) {
    initCarousels(scope);
    initCountdowns(scope);
    collectParallax(scope);
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
